import { formatPrice } from 'utils/utils.js';

export function handleData(skusList, combinationList) {
  const columns = [];
  const dataSource = [];

  // 确定表头
  skusList.forEach(skusItem => {
    if (skusItem.childList.length) {
      columns.push({
        title: skusItem.name,
        dataIndex: skusItem.name,
        width: 100,
      });
    }
  });

  // 确定表格展示数据
  combinationList.forEach((combinedItem, index) => {
    const props = {};
    const { originalPrice } = combinedItem;

    combinedItem.specifications.forEach(specItem => {
      props[specItem.name] = specItem.value;
    });
    dataSource.push({
      id: combinedItem.id,
      key: index,
      price:
        originalPrice === null || originalPrice === ''
          ? ''
          : formatPrice(originalPrice, { isToString: false }),
      ...props,
    });
  });

  return { columns, dataSource };
}



// WEBPACK FOOTER //
// ./src/components_business/SkusEdit/SkusTable/util.js